import { ROLE_ACCESS } from '@/constant/storage';
import useCourseDetailPermission from '@/hooks/course/useCourseDetailPermission';
import { ILastestSubscriptionPlanResponse } from '@/interfaces/subscription.interface';
import { ICourseDetailResponse } from '@/interfaces/training.interface';
import { PropsWithChildren, createContext } from 'react';
import { UseQueryResult } from 'react-query';

interface ICourseDetailPermissionContext {
  mineRole: ROLE_ACCESS;
  roleQueryReturn: UseQueryResult<ROLE_ACCESS, unknown> | undefined;
  courseDetailQueryReturn:
    | UseQueryResult<ICourseDetailResponse, unknown>
    | undefined;
  fullyLock: boolean;
  eachLock: boolean;
  fullAccess: boolean;
  latestSubscription: ILastestSubscriptionPlanResponse | undefined;
}

export const CourseDetailPermissionContext =
  createContext<ICourseDetailPermissionContext>({
    mineRole: ROLE_ACCESS.Viewer,
    roleQueryReturn: undefined,
    courseDetailQueryReturn: undefined,
    fullAccess: false,
    fullyLock: true,
    eachLock: false,
    latestSubscription: undefined,
  });

export default function CourseDetailPermissionProvider({
  children,
  data,
}: PropsWithChildren<{ data: ICourseDetailResponse }>) {
  const props = useCourseDetailPermission(data);

  return (
    <CourseDetailPermissionContext.Provider value={props}>
      {children}
    </CourseDetailPermissionContext.Provider>
  );
}
